import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'PROCESSO_LOGISTICA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('processoLogisticaForm', registro)
    ];
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/processoLogistica`);
    return {
        type: 'PROCESSO_LOGISTICA_LISTADO',
        payload: request
    };
}

export function getListaVencido() {
    const request = axios.get(`${consts.API_URL}/processoLogistica/listarVencidos`);
    return {
        type: 'PROCESSO_LOGISTICA_VENCIDO_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {

		if (!registro.id) {
	        axios.post(`${consts.API_URL}/processoLogistica`, {
                ...registro,
                data_realizacao: DateFormat.formatarDataTelaParaSql(registro.data_realizacao),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(getListaVencido());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/processoLogistica`, {
                ...registro,
                data_realizacao: DateFormat.formatarDataTelaParaSql(registro.data_realizacao),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(getListaVencido());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/processoLogistica?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(getListaVencido());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaUnidade() {
    const request = axios.get(`${consts.API_URL}/unidade/listarSelect`);
    return {
        type: 'PROCESSO_LOGISTICA_UNIDADE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaTipo() {
    const request = axios.get(`${consts.API_URL}/processoLogisticaTipo/listarSelect`);
    return {
        type: 'PROCESSO_LOGISTICA_TIPO_SELECT_LISTADO',
        payload: request
    };
}	